import { ChronoIcon } from "@/public/icons/ChronoIcon";
import { SliderDurationIcon } from "@/public/icons/SliderDurationIcon";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./Offer.module.scss";
import { OfferButton } from "./offerButton/OfferButton";

export type OfferProps = {
  title: string;
  subtitle: string;
  description: string;
  bottomTitle: string;
  bottomDescription: string;
  isChrono: boolean;
};

export const Offer = ({
  title,
  subtitle,
  description,
  bottomTitle,
  bottomDescription,
  isChrono,
}: OfferProps) => {
  return (
    <div className={styles.offer}>
      {isChrono && (
        <div className={styles.backgroundImage}>
          <ChronoIcon />
        </div>
      )}
      {!isChrono && (
        <div className={styles.backgroundImage}>
          {" "}
          <SliderDurationIcon />
        </div>
      )}
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle}>{subtitle}</p>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={injectPurifiedHTML(
          removeEmptyRel(description)
        )}
      />
      <OfferButton
        title={bottomTitle}
        description={bottomDescription}
        isReverse={!isChrono}
      />
    </div>
  );
};
